import * as Turbo from '@hotwired/turbo'
import * as bootstrap from 'bootstrap'
import '../apps/slider'
import cookieConsentModal from './js/cookie_consent_modal.js'
import '../apps/search'

Turbo.start()
document.addEventListener("turbo:load", cookieConsentModal);
document.addEventListener("turbo:load", onLoad);
document.addEventListener("turbo:submit-end", onLoad);
function onLoad() {

  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const utmCampaign = urlParams.get('utm_campaign');
  const utmMedium = urlParams.get('utm_medium');
  const utmConent = urlParams.get('utm_content');
  const utmToken = localStorage.getItem('utm_token');

  if (utmCampaign || utmMedium || utmConent){
      fetch("https://api.eat-performance.com/u/new", {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
          },
          method: "POST",
          body: JSON.stringify({utm_campaign: utmCampaign, utm_medium: utmMedium, utm_content: utmConent})
      })
      .then(response => response.json())
      .then(function(data){ 
          localStorage.setItem('utm_token', data.token);
      })
  }
  const orderElement = document.getElementsByClassName("finish-ordernumber")[0];

  if (orderElement && utmToken){
      fetch("https://api.eat-performance.com/u/finished", {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
          },
          method: "POST",
          body: JSON.stringify({
              token: utmToken,
              order_token: orderElement.dataset.token
          })
      })
      .then(function(data){ 
          localStorage.removeItem('utm_token');
      })
  }

  document.querySelectorAll('.address-form').forEach(form => {
    const lockerCheckbox = form.querySelector('input[type="checkbox"].is_locker');
    const requiredHTML = '&nbsp;<abbr title="Pflichtfeld">*</abbr>'
    if (!lockerCheckbox) return;

    const onInput = (event) => {
      if (/\d{4,}/.test(event.target.value)) {
        document.getElementById("street-locker-notice").style.display = "block"
      } else {
        document.getElementById("street-locker-notice").style.display = "none"
      }
    }

    const updateLockerLabels = (clear) => {
      const isLocker = lockerCheckbox.checked;

      form.querySelectorAll('.locker-input').forEach(input => {
        const lockerText = input.dataset.lockerLabel;
        const normalText = input.dataset.label;
        
        if(clear) input.value = ""

        input.removeEventListener("input", onInput);
        if (isLocker && lockerText !== undefined) {
          document.getElementById("street-locker-notice").style.display = "none"
          input.placeholder = lockerText;
        } else if (!isLocker && normalText !== undefined) {
          input.placeholder = normalText;
          if (input.classList.contains("is-street")) input.addEventListener("input", onInput);
        }
      });

      form.querySelectorAll('label.locker-label').forEach(label => {
        const lockerText = label.dataset.lockerLabel;
        const normalText = label.dataset.label;

        if (isLocker && lockerText !== undefined) {
          label.innerHTML = lockerText + requiredHTML;
        } else if (!isLocker && normalText !== undefined) {
          label.innerHTML = normalText + requiredHTML;
        }
      });
    };

    updateLockerLabels();

    lockerCheckbox.addEventListener('change', (x) => {
      updateLockerLabels(true)
    })
  });


  const passwordField = document.querySelector("#password_fields #user_password");
  const confirmFields = document.querySelectorAll('#password_fields #user_password_confirmation');

  function validatePasswords(confirmField, message) {
      if (confirmField.value && passwordField.value !== confirmField.value) {
          message.textContent = "Passwörter stimmen nicht überein";
          message.style.color = "red";
      } else {
          message.textContent = "";
      }
  }

  confirmFields.forEach(confirmField => {

      const message = document.createElement("div");
      confirmField.insertAdjacentElement("afterend", message);

      // Check when confirmation field changes
      confirmField.addEventListener("input", () => {
          validatePasswords(confirmField, message);
      });

      // Check when password field changes
      passwordField.addEventListener("input", () => {
          validatePasswords(confirmField, message);
      });
  });

  const eyeOpenSVG = `
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  `;

  const eyeClosedSVG = `
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.77 21.77 0 0 1 5.06-6.94"/>
      <path d="M1 1l22 22"/>
      <path d="M9.53 9.53A3.5 3.5 0 0 0 12 15.5a3.5 3.5 0 0 0 2.47-.97"/>
      <path d="M14.47 14.47A3.5 3.5 0 0 0 9.53 9.53"/>
      <path d="M12 4c7 0 11 8 11 8a21.78 21.78 0 0 1-4.21 5.11"/>
    </svg>
  `;

  document.querySelectorAll('input[type="password"]').forEach(input => {
    // Wrapper
    const wrapper = document.createElement("div");
    wrapper.style.position = "relative";
    wrapper.style.display = "inline-block";
    wrapper.style.width = "100%";

    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(input);

    // Icon Button
    const toggleBtn = document.createElement("button");
    toggleBtn.type = "button";
    toggleBtn.innerHTML = eyeOpenSVG;
    toggleBtn.style.position = "absolute";
    toggleBtn.style.right = "10px";
    toggleBtn.style.top = "50%";
    toggleBtn.style.transform = "translateY(-50%)";
    toggleBtn.style.border = "none";
    toggleBtn.style.background = "transparent";
    toggleBtn.style.cursor = "pointer";
    toggleBtn.style.padding = "0";
    toggleBtn.style.color = "#666";
    toggleBtn.tabIndex = -1;
    toggleBtn.setAttribute("aria-label", "Passwort anzeigen");
    toggleBtn.setAttribute("aria-pressed", "false");

    wrapper.appendChild(toggleBtn);

    toggleBtn.addEventListener("mousedown", (e) => {
      e.preventDefault();
    });

    toggleBtn.addEventListener("click", () => {
      const isPassword = input.type === "password";
      input.type = isPassword ? "text" : "password";
      toggleBtn.innerHTML = isPassword ? eyeClosedSVG : eyeOpenSVG;
      toggleBtn.setAttribute("aria-pressed", isPassword ? "true" : "false");
      toggleBtn.setAttribute(
        "aria-label",
        isPassword ? "Passwort verbergen" : "Passwort anzeigen"
      );
    });
  });

  document.querySelector('#faq_page') &&
  (() => {

    if (!window.location.hash) return false
    const collapseEl = document.querySelector(window.location.hash);

    collapseEl?.classList.contains('accordion-collapse') &&
      new bootstrap.Collapse(collapseEl, { toggle: false }).show();

    collapseEl?.addEventListener(
      'shown.bs.collapse',
      () => collapseEl.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      }),
      { once: true }
    );

  })()

  const paypalHtmlButton = document.querySelectorAll('#paypal-button')
  paypalHtmlButton.forEach(btn => {
    const orderId = btn.dataset.id
    paypal.getFundingSources().forEach(function(fundingSource) {
      let paypalButton = paypal.Buttons({
        fundingSource: fundingSource,
        createOrder: async (data, actions) => {
          return orderId;
        },
        onApprove: async (data, actions) => {
          const captureResp = await fetch('/paypal/approve', {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
            },
            body: JSON.stringify({ orderID: orderId })
          });
          const result = await captureResp.json();
          if (result.email && result.full_amount){
            window.dataLayer && dataLayer.push({event: 'purchase', value: result.full_amount, currency: 'EUR', email: result.email, number: result.number});
            if (typeof fbq !== "undefined") fbq('track','Purchase',{value:result.full_amount,currency:'EUR'});
          }
          location.href = result.redirect_to_url
        },
        onClick: (data, actions) => {
        }
      })
      
      if(document.querySelector('.paypal-spinner')) document.querySelector('.paypal-spinner').remove();
      if (paypalButton.isEligible() && fundingSource != "trustly" && fundingSource != "satispay") {
        paypalButton.render('#paypal-button');
      }
    })
  })

  const track = document.querySelector(".slider-track");
  const slides = document.querySelectorAll(".slide");
  const prevBtn = document.querySelector(".prev");
  const nextBtn = document.querySelector(".next");

  let slidesPerView = getSlidesPerView();
  let currentPage = 0;

  function getSlidesPerView() {
    const width = window.innerWidth;
    if (width >= 900) return 3;
    if (width >= 600) return 2;
    return 1;
  }

  function getTotalPages() {
    return Math.ceil(slides.length / slidesPerView);
  }

  function updateSlider() {
    if (!slides[0]) return false
    const slideWidth = slides[0].offsetWidth + 20; // 20px gap
    const offset = currentPage * slideWidth * slidesPerView;
    track.style.transform = `translateX(-${offset}px)`;

    // Pfeile abhängig von Seitenposition anzeigen/verstecken
    const totalPages = getTotalPages();
    prevBtn.style.display = currentPage === 0 ? 'none' : 'block';
    nextBtn.style.display = currentPage >= totalPages - 1 ? 'none' : 'block';
    nextBtn.style.display = 'block';
  }

  function nextSlide() {
    const totalPages = getTotalPages();
    if (currentPage < totalPages - 1) {
      currentPage++;
      updateSlider();
    }
  }

  function prevSlide() {
    if (currentPage > 0) {
      currentPage--;
      updateSlider();
    }
  }

  if (nextBtn) nextBtn.addEventListener("click", nextSlide);
  if (prevBtn) prevBtn.addEventListener("click", prevSlide);

  window.addEventListener("resize", () => {
    const newSlidesPerView = getSlidesPerView();
    if (newSlidesPerView !== slidesPerView) {
      slidesPerView = newSlidesPerView;
      const totalPages = getTotalPages();
      if (currentPage > totalPages - 1) {
        currentPage = totalPages - 1;
      }
      updateSlider();
    }
  });

  // Initiales Setup
  updateSlider();


  const selects = document.querySelectorAll(".trigger-select");

  selects.forEach(select => {
    // Das zugehörige DIV direkt unterhalb suchen
    const container = select.parentElement.nextElementSibling;

    function updateVisibility() {
        if (select.value === "") {
            container.classList.remove("d-none");
        } else {
            container.classList.add("d-none");
        }
    }

    // Initial prüfen
    updateVisibility();

    // Bei Änderung prüfen
    select.addEventListener("change", updateVisibility);
  });


  let submitOnChange = document.querySelectorAll('.submit-on-change');
  submitOnChange.forEach(e => {
    e.addEventListener('change', (event) => {
      setTimeout(() => {
        e.parentElement.submit()
      }, 200);
    })
  })

  function initializeZoomGallery(mainContainerId, thumbnailGalleryId) {
    const mainContainer = document.getElementById(mainContainerId);
    if (!mainContainer) return false
    const originalImage = mainContainer.querySelector('img'); // Das <img> im Hauptcontainer
    const thumbnailGallery = document.getElementById(thumbnailGalleryId);
    const thumbnails = thumbnailGallery.querySelectorAll('img');

    let currentZoomedImage = null; // Aktuell geladenes Zoom-Bild
    let containerWidth, containerHeight;
    let zoomedImageNaturalWidth, zoomedImageNaturalHeight;
    let offsetX, offsetY;
    const magnify = 2; // Zoomfaktor

    // Funktion zum Aktualisieren des Hauptbildes und des Zoom-Bildes
    // Nimmt jetzt die src vom geklickten Thumbnail entgegen
    function updateMainImage(src) {
        originalImage.src = src; // Aktualisiert das sichtbare Hauptbild

        // Entfernt das alte Zoom-Bild, falls vorhanden
        if (currentZoomedImage && currentZoomedImage.parentNode === mainContainer) {
            mainContainer.removeChild(currentZoomedImage);
        }

        // Erstellt ein neues Zoom-Bild
        const newZoomedImage = new Image();
        newZoomedImage.classList.add('zoom-image');
        newZoomedImage.src = src; // Verwendet dieselbe src für das Zoom-Bild
        newZoomedImage.alt = originalImage.alt + ' (gezoomt)';
        newZoomedImage.setAttribute('role', 'presentation');

        newZoomedImage.onload = () => {
            mainContainer.appendChild(newZoomedImage);
            // Standardmäßig unsichtbar, wird bei Mouseenter eingeblendet
            newZoomedImage.style.opacity = 0;

            containerWidth = mainContainer.offsetWidth;
            containerHeight = mainContainer.offsetHeight;

            zoomedImageNaturalWidth = newZoomedImage.naturalWidth;
            zoomedImageNaturalHeight = newZoomedImage.naturalHeight;

            newZoomedImage.style.width = (zoomedImageNaturalWidth * magnify) + 'px';
            newZoomedImage.style.height = (zoomedImageNaturalHeight * magnify) + 'px';

            offsetX = (zoomedImageNaturalWidth * magnify) - containerWidth;
            offsetY = (zoomedImageNaturalHeight * magnify) - containerHeight;

            currentZoomedImage = newZoomedImage; // Speichert das neue Zoom-Bild
        };
    };

    // Event Listener für die Vorschaubilder
    thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {
            // Entferne die 'active-thumbnail'-Klasse von allen Vorschaubildern
            thumbnails.forEach(t => t.classList.remove('active-thumbnail'));
            // Füge die 'active-thumbnail'-Klasse zum geklickten Vorschaubild hinzu
            thumbnail.classList.add('active-thumbnail');

            const imageSrc = thumbnail.src; // Direkt das src-Attribut verwenden
            updateMainImage(imageSrc);
        });
    });

    // Mausbewegungs-Logik für den Zoom-Container
    mainContainer.addEventListener('mousemove', (e) => {
        if (!currentZoomedImage || zoomedImageNaturalWidth === 0 || zoomedImageNaturalHeight === 0) return;

        const containerRect = mainContainer.getBoundingClientRect();
        const mouseX = e.clientX - containerRect.left;
        const mouseY = e.clientY - containerRect.top;

        const clampedMouseX = Math.max(0, Math.min(mouseX, containerWidth));
        const clampedMouseY = Math.max(0, Math.min(mouseY, containerHeight));

        const percentX = clampedMouseX / containerWidth;
        const percentY = clampedMouseY / containerHeight;

        const moveX = -1 * (percentX * offsetX);
        const moveY = -1 * (percentY * offsetY);

        currentZoomedImage.style.left = moveX + 'px';
        currentZoomedImage.style.top = moveY + 'px';
    });

    // Mouseenter/Mouseleave-Logik für den Zoom-Container
    mainContainer.addEventListener('mouseenter', () => {
        if (currentZoomedImage) {
            currentZoomedImage.style.opacity = 1;
        }
    });

    mainContainer.addEventListener('mouseleave', () => {
        if (currentZoomedImage) {
            currentZoomedImage.style.opacity = 0;
        }
    });

    // Initialisiere das Hauptbild und Zoom-Bild basierend auf dem aktiven Vorschaubild beim Laden
    const initialActiveThumbnail = thumbnailGallery.querySelector('.active-thumbnail');
    if (initialActiveThumbnail) {
        const initialSrc = initialActiveThumbnail.src; // Direkt das src-Attribut verwenden
        updateMainImage(initialSrc);
    }
    // Überprüfen, ob initialActiveThumbnail undefined ist
    else if (thumbnails.length > 0) {
         // Wenn kein aktives Thumbnail gefunden wurde, wähle das erste als Standard aus
         thumbnails[0].classList.add('active-thumbnail');
         const initialSrc = thumbnails[0].src;
         updateMainImage(initialSrc);
    }
  }

  initializeZoomGallery('myZoomContainer', 'thumbnailGallery');
  
  const checkbox = document.getElementById("show_shipping_checkbox") || document.getElementById("shop_order_show_shipping");
  const shippingFields = document.getElementById("shipping_fields");

  if (checkbox) {
    shippingFields.style.display = checkbox.checked ? "block" : "none";
    checkbox.addEventListener("change", () => {
      shippingFields.style.display = checkbox.checked ? "block" : "none";
    });
  }

  const checkbox2 = document.getElementById("shop_order_create_user");
  const passwordFields = document.getElementById("password_fields");

  if (checkbox2) {
    passwordFields.style.display = checkbox2.checked ? "block" : "none";
    checkbox2.addEventListener("change", () => {
      passwordFields.style.display = checkbox2.checked ? "block" : "none";
    });
  }

  const addToCart = document.querySelectorAll('.add-button')
  addToCart.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault()
      button.closest('.product-container').classList.toggle('product-container-clicked');
      const value = parseFloat(button.dataset.price) * parseFloat(button.parentElement.querySelector(".quantity-input").value)
      window.dataLayer && dataLayer.push({event: 'add_to_cart', value: value, currency: 'EUR'});
      if (typeof fbq !== "undefined") fbq('track','AddToCart', {content_ids:[button.dataset.ean], content_type:'product', value: value, currency:'EUR'});
      event.target.form.submit()
    })
  })

  const directCheckout = document.querySelectorAll('.direct-checkout')
  directCheckout.forEach(button => {
    button.addEventListener('click', (event) => {
      window.dataLayer && dataLayer.push({event: 'purchase', value: 0.0, currency: 'EUR', email: button.dataset.email});
      if (typeof fbq !== "undefined") fbq('track','Purchase',{value:0.0,currency:'EUR'});
    })
  })


  const popoverTriggerList = document.querySelectorAll('.popover-trigger')
  popoverTriggerList.forEach(myPopoverEl => {
    var popover = new bootstrap.Popover(myPopoverEl, {
      content: document.getElementById(myPopoverEl.dataset.popoverId).innerHTML,
      html: true,
      trigger: 'focus',
      sanitize: false,
      placement: "bottom",
      customClass: myPopoverEl.dataset.popoverId
    });
    myPopoverEl.addEventListener('click', (event) => {
      event.preventDefault();
      let logoutLinks = document.querySelectorAll('.logout-link');
      logoutLinks.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          fetch(button.href, {
            method: "DELETE",
            headers: {
              "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
            }
          })
          .then(response => {
            if (response.ok) {
              Turbo.visit("/");
            } else {
              console.error("Löschen fehlgeschlagen");
            }
          });

        })
      })
    })
  })
  
  let toggleMenuButtons = document.querySelectorAll('.menu-toggle');
  toggleMenuButtons.forEach(button => {
    button.addEventListener('click', () => {
      document.getElementById('nav').classList.toggle('show');
    })
  })

  let toggleSearchButtons = document.querySelectorAll('.search-toggle');
  toggleSearchButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      document.getElementsByClassName('search-area')[0].classList.toggle('search-open');
    })
  })

  let toggleDropDownButtons = document.querySelectorAll('.toggle-dropdown');
  toggleDropDownButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      const screenWidth = window.innerWidth;
      if (screenWidth > 768) return; // Nur auf Mobile togglen
      event.preventDefault();
      const dropdown = button.parentElement.querySelector(".dropdown-menu");
      if (dropdown.style.display === 'block'){
        dropdown.style.display = "none";
        button.parentElement.querySelector("svg path").setAttribute("d", "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z")
      } else {
        dropdown.style.display = "block";
        button.parentElement.querySelector("svg path").setAttribute("d", "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z")
      }
    })
  })


  let asyncButtons = document.querySelectorAll('.async-button');
  asyncButtons.forEach(e => {
    e.addEventListener('click', (event) => {
      event.preventDefault();

      let params

      if (document.getElementById(e.id.replace("-btn", "-input"))){
        params = JSON.stringify({input: document.getElementById(e.id.replace("-btn", "-input")).value})
      }
      
      fetch(e.dataset.url, {
        method: e.dataset.method || 'DELETE',
        body: params,
        headers: {
          "X-CSRF-Token": e.dataset.authenticityToken,
          "Content-Type": "application/json"
        }
      }).then(response => {
        if (response.status == 305){
          location.reload()
        } else if (response.redirected || response.status == 301) {
          window.location.href = response.url;
        }
      })
    })
  })
  document.querySelectorAll(".quantity-button").forEach(function (button) {
    button.addEventListener("click", function () {
      // Das übergeordnete .cart-controls finden
      const cartControls = this.closest(".cart-controls");

      // Das Input innerhalb der .bubble im gleichen Block finden
      const input = cartControls.querySelector(".bubble .quantity-input");

      // Aktuellen Wert als Zahl holen
      let value = parseInt(input.value, 10);

      // Wenn es keine gültige Zahl ist, zurücksetzen auf 1
      if (isNaN(value)) value = 1;

      // Entscheiden ob + oder -
      if (this.textContent === "+") {
        value++;
      } else if (this.textContent === "−" && value > 1) {
        value--;
      }

      // Neuen Wert ins Input schreiben
      input.value = value;
    });
  });
}
